export default "__VITE_PUBLIC_ASSET__f8b17bb0__"